var React = require('react');

function IconArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 1L5 5L9 1","stroke":"none","strokeWidth":"1.5"}));
}

IconArrowDown.defaultProps = {"width":"10","height":"7","viewBox":"0 0 10 7","fill":"none"};

module.exports = IconArrowDown;

IconArrowDown.default = IconArrowDown;
